import { faArrowUpRightFromSquare, faHotel, faLocationDot, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import React, { ChangeEvent, useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { OverlayTrigger } from 'ui'
import { getGroupedChains } from '../../../utils/bookerUtils'
import Field from './Field'
import { BookerContext } from '../Booker'
import { useScrollWithShadow } from '../../../hooks/useScrollWithShadows'
import { cn, cnWithPrefix } from 'ui/lib/utils'

export type DestinationBookerType = {
   id: number
   name: string
   airportCode: string
}

export type ChainBookerType = {
   id: number
   name: string
}

export type HotelBookerType = {
   id: number
   name: string
   url?: string
   destination: DestinationBookerType
   chain?: ChainBookerType | null
   isExternal?: boolean
   alternativePath?: string
}

type Props = {
   hotelList: Array<HotelBookerType>
   selection?: {
      id: number
      destinationType: 'hotel' | 'destination'
      aiportCode?: string
   }
   onSelect: Function
   myErrors: any
   hasMultiDestination: boolean
   showChains?: boolean
}

type OptionType = {
   destination: DestinationBookerType
   hotels: Array<HotelBookerType>
   nonSelectable: boolean
}

type ChainOptionType = {
   chain: ChainBookerType | null
   items: Array<OptionType>
}

export const BedIcon = ({ className }: { className?: string }) => {
   const { useTailwindPrefix } = useContext(BookerContext)
   const customCn = useTailwindPrefix ? cnWithPrefix('tw-') : cn
   return (
      <svg
         className={customCn(
            {
               'h-[1em] overflow-visible box-content': !useTailwindPrefix,
               'tw-h-[1em] tw-overflow-visible tw-box-content': useTailwindPrefix,
            },
            className,
         )}
         viewBox={`0 0 25 24`}
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M2.91174 18V13C2.91174 12.55 3.00341 12.1417 3.18674 11.775C3.37008 11.4083 3.61174 11.0833 3.91174 10.8V8C3.91174 7.16667 4.20341 6.45833 4.78674 5.875C5.37008 5.29167 6.07841 5 6.91174 5H10.9117C11.2951 5 11.6534 5.07083 11.9867 5.2125C12.3201 5.35417 12.6284 5.55 12.9117 5.8C13.1951 5.55 13.5034 5.35417 13.8367 5.2125C14.1701 5.07083 14.5284 5 14.9117 5H18.9117C19.7451 5 20.4534 5.29167 21.0367 5.875C21.6201 6.45833 21.9117 7.16667 21.9117 8V10.8C22.2117 11.0833 22.4534 11.4083 22.6367 11.775C22.8201 12.1417 22.9117 12.55 22.9117 13V18C22.9117 18.2833 22.8159 18.5208 22.6242 18.7125C22.4326 18.9042 22.1951 19 21.9117 19C21.6284 19 21.3909 18.9042 21.1992 18.7125C21.0076 18.5208 20.9117 18.2833 20.9117 18V17H4.91174V18C4.91174 18.2833 4.81591 18.5208 4.62424 18.7125C4.43258 18.9042 4.19508 19 3.91174 19C3.62841 19 3.39091 18.9042 3.19924 18.7125C3.00758 18.5208 2.91174 18.2833 2.91174 18ZM13.9117 10H19.9117V8C19.9117 7.71667 19.8159 7.47917 19.6242 7.2875C19.4326 7.09583 19.1951 7 18.9117 7H14.9117C14.6284 7 14.3909 7.09583 14.1992 7.2875C14.0076 7.47917 13.9117 7.71667 13.9117 8V10ZM5.91174 10H11.9117V8C11.9117 7.71667 11.8159 7.47917 11.6242 7.2875C11.4326 7.09583 11.1951 7 10.9117 7H6.91174C6.62841 7 6.39091 7.09583 6.19924 7.2875C6.00758 7.47917 5.91174 7.71667 5.91174 8V10ZM4.91174 15H20.9117V13C20.9117 12.7167 20.8159 12.4792 20.6242 12.2875C20.4326 12.0958 20.1951 12 19.9117 12H5.91174C5.62841 12 5.39091 12.0958 5.19924 12.2875C5.00758 12.4792 4.91174 12.7167 4.91174 13V15Z"
            fill="currentColor"
         />
      </svg>
   )
}
const PinIcon = ({ className }: { className?: string }) => {
   const { useTailwindPrefix } = useContext(BookerContext)
   const customCn = useTailwindPrefix ? cnWithPrefix('tw-') : cn
   return (
      <svg
         className={customCn(
            {
               'h-[1em] overflow-visible box-content': !useTailwindPrefix,
               'tw-h-[1em] tw-overflow-visible tw-box-content': useTailwindPrefix,
            },
            className,
         )}
         viewBox="0 0 24 24"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M12 16.475C13.65 15.1417 14.8958 13.8583 15.7375 12.625C16.5792 11.3917 17 10.2333 17 9.15C17 7.65 16.5333 6.41667 15.6 5.45C14.6667 4.48333 13.4667 4 12 4C10.5333 4 9.33333 4.48333 8.4 5.45C7.46667 6.41667 7 7.65 7 9.15C7 10.2333 7.42083 11.3917 8.2625 12.625C9.10417 13.8583 10.35 15.1417 12 16.475ZM12 18.525C11.8 18.525 11.6 18.4917 11.4 18.425C11.2 18.3583 11.0167 18.2583 10.85 18.125C8.88333 16.5583 7.41667 15.0292 6.45 13.5375C5.48333 12.0458 5 10.5833 5 9.15C5 7.06667 5.65 5.35417 6.95 4.0125C8.25 2.67083 9.93333 2 12 2C14.0667 2 15.75 2.67083 17.05 4.0125C18.35 5.35417 19 7.06667 19 9.15C19 10.5833 18.5167 12.0458 17.55 13.5375C16.5833 15.0292 15.1167 16.5583 13.15 18.125C12.9833 18.2583 12.8 18.3583 12.6 18.425C12.4 18.4917 12.2 18.525 12 18.525ZM12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11ZM6 22C5.71667 22 5.47917 21.9042 5.2875 21.7125C5.09583 21.5208 5 21.2833 5 21C5 20.7167 5.09583 20.4792 5.2875 20.2875C5.47917 20.0958 5.71667 20 6 20H18C18.2833 20 18.5208 20.0958 18.7125 20.2875C18.9042 20.4792 19 20.7167 19 21C19 21.2833 18.9042 21.5208 18.7125 21.7125C18.5208 21.9042 18.2833 22 18 22H6Z"
            fill="currentColor"
         />
      </svg>
   )
}

const HotelSelector = ({ hotelList, selection, onSelect, myErrors, hasMultiDestination, showChains }: Props) => {
   const intl = useIntl()
   const { vertical, useTailwindPrefix, version, showArrows, showLabels } = useContext(BookerContext)
   const originalOptions = getGroupedChains(hotelList)
   const [options, setOptions] = useState(originalOptions)
   const [isOpen, setIsOpen] = useState(false)
   const { containerRef, drawShadows, onScrollHandler, parentStyle } = useScrollWithShadow(useTailwindPrefix)
   const [searchInputValue, setSearchInputValue] = useState('')

   const hasMultipleDestinations = hasMultiDestination
   const showTitles = originalOptions.flatMap((o) => o.items).some((p) => p.hotels.length > 1)
   const hasManyResults =
      hotelList.length > 8 || (hasMultipleDestinations && originalOptions.flatMap((o) => o.items).length > 3)

   function onSelectEvent(data: any) {
      closeSelector()
      onSelect(data)
   }

   function closeSelector() {
      onToggle(false)
      setSearchInputValue('')
      setOptions(originalOptions)
   }

   function onToggle(data: boolean) {
      setIsOpen(data)
      if (data) {
         if (document && document.body) {
            let orig = document.body.className
            if (!useTailwindPrefix) {
               if (orig.indexOf('fixed md:relative') < 0) {
                  document.body.className = orig + (orig ? ' ' : '') + 'fixed md:relative'
               }
            } else {
               if (orig.indexOf('tw-fixed md:tw-relative') < 0) {
                  document.body.className = orig + (orig ? ' ' : '') + 'tw-fixed md:tw-relative'
               }
            }
         }
      } else {
         if (document && document.body) {
            if (!useTailwindPrefix) {
               document.body.className = document.body.className.replace(/ ?fixed md:relative/, '')
            } else {
               document.body.className = document.body.className.replace(/ ?tw-fixed md:tw-relative/, '')
            }
         }
      }
   }

   function renderChainOptions(option: ChainOptionType) {
      const result = []

      if (showChains && originalOptions.length > 1) {
         result.push(
            <div
               className={classNames({
                  'bg-[#EEEEEE]': !useTailwindPrefix,
                  'tw-bg-[#EEEEEE]': useTailwindPrefix,
                  'overflow-x-hidden basis-full': hasManyResults && !useTailwindPrefix,
                  'tw-overflow-x-hidden tw-basis-full': hasManyResults && useTailwindPrefix,
               })}
            >
               <div
                  className={classNames({
                     'py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis': !useTailwindPrefix,
                     'tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis': useTailwindPrefix,
                     invisible: (!option.chain || option.chain.name === '') && !useTailwindPrefix,
                     'tw-invisible': (!option.chain || option.chain.name === '') && useTailwindPrefix,
                  })}
               >
                  {option.chain?.name || '.'}
               </div>
            </div>,
         )
      }

      result.push(option.items.map(renderOptions))
      return result
   }

   function renderOptions(option: OptionType) {
      let result = []

      if (showTitles && hasMultipleDestinations) {
         const onDestinationSelection = () => {
            onSelectEvent({
               id: option.destination.id,
               destinationType: 'destination',
               airportCode: option.destination.airportCode,
            })
         }

         result.push(
            <div
               className={classNames({
                  'bg-[#EEEEEE]':
                     selection?.id === option.destination.id &&
                     selection.destinationType === 'destination' &&
                     !useTailwindPrefix,
                  'tw-bg-[#EEEEEE]':
                     selection?.id === option.destination.id &&
                     selection.destinationType === 'destination' &&
                     useTailwindPrefix,
                  'overflow-x-hidden basis-full': hasManyResults && !useTailwindPrefix,
                  'tw-overflow-x-hidden tw-basis-full': hasManyResults && useTailwindPrefix,
               })}
               key={`destination-${option.destination.id}`}
            >
               <div
                  className={classNames({
                     'flex justify-between items-center py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis bg-[#EEEEEE]':
                        !useTailwindPrefix,
                     'tw-flex tw-justify-between tw-items-center tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-bg-[#EEEEEE]':
                        useTailwindPrefix,
                     'hover:bg-neutral-100 cursor-pointer': !option.nonSelectable && !useTailwindPrefix,
                     'hover:tw-bg-neutral-100 tw-cursor-pointer': !option.nonSelectable && useTailwindPrefix,
                  })}
                  {...(!option.nonSelectable && { onClick: onDestinationSelection })}
               >
                  {option.destination.name}
                  {!option.nonSelectable && (
                     <span
                        className={classNames({
                           'text-xs text-link-blue': !useTailwindPrefix,
                           'tw-text-xs tw-text-link-blue': useTailwindPrefix,
                        })}
                     >
                        {intl.formatMessage({ id: 'booker.select.destination' })}
                     </span>
                  )}
               </div>
            </div>,
         )
      }

      option.hotels.forEach((hotel) => {
         const clickHotel = () => {
            onSelectEvent({
               id: hotel.id,
               destinationType: 'hotel',
               airportCode: hotel.destination.airportCode,
            })
         }
         const classes = classNames({
            'bg-neutral-100': selection?.id === hotel.id && selection.destinationType === 'hotel' && !useTailwindPrefix,
            'tw-bg-neutral-100':
               selection?.id === hotel.id && selection.destinationType === 'hotel' && useTailwindPrefix,
            'overflow-x-hidden basis-full md:basis-1/2 lg:basis-1/3': hasManyResults && !useTailwindPrefix,
            'tw-overflow-x-hidden tw-basis-full md:tw-basis-1/2 lg:tw-basis-1/3': hasManyResults && useTailwindPrefix,
         })
         if (hotel.isExternal) {
            result.push(
               <div key={`hotel-${hotel.id}`} className={classes}>
                  <a
                     href={hotel.url}
                     target="_blank"
                     className={classNames({
                        'flex items-center justify-between py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis hover:bg-neutral-100 cursor-pointer':
                           !useTailwindPrefix,
                        'tw-flex tw-items-center tw-justify-between tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis hover:tw-bg-neutral-100 tw-cursor-pointer':
                           useTailwindPrefix,
                     })}
                  >
                     <span>
                        {hotel.name}
                        {hotel.destination.name && (
                           <span
                              className={classNames({
                                 'block text-base text-gray-400': !useTailwindPrefix,
                                 'tw-block tw-text-base tw-text-gray-400': useTailwindPrefix,
                              })}
                           >
                              {hotel.destination.name}
                           </span>
                        )}
                     </span>
                     <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                        className="text-neutral-300 tw-text-neutral-300"
                     />
                  </a>
               </div>,
            )
         } else {
            result.push(
               <div key={`hotel-${hotel.id}`} className={classes}>
                  <div
                     className={classNames({
                        'block py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis hover:bg-neutral-100 cursor-pointer':
                           !useTailwindPrefix,
                        'tw-block tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis hover:tw-bg-neutral-100 tw-cursor-pointer':
                           useTailwindPrefix,
                     })}
                     onClick={clickHotel}
                  >
                     {hotel.name}
                     {hotel.destination.name && (
                        <span
                           className={classNames({
                              'block text-base text-gray-400': !useTailwindPrefix,
                              'tw-block tw-text-base tw-text-gray-400': useTailwindPrefix,
                           })}
                        >
                           {hotel.destination.name}
                        </span>
                     )}
                  </div>
               </div>,
            )
         }
      })

      return result
   }

   function drawSelection() {
      let result = null
      if (selection && hotelList.length > 0) {
         if (selection.destinationType === 'hotel') {
            result = hotelList.find((h) => h.id === selection.id)
         } else {
            result = options.flatMap((o) => o.items).find((o) => o.destination?.id === selection.id)?.destination
         }
      }
      return result ? result.name : null
   }

   const bodyClassName = classNames({
      'md:rounded-widget-pill-overlays-border-radius-inner': !useTailwindPrefix && !vertical && version === 'padded',
      'md:tw-rounded-widget-pill-overlays-border-radius-inner': useTailwindPrefix && !vertical && version === 'padded',
      'fixed overflow-auto inset-0 top-[50px] md:inset-auto md:relative': !useTailwindPrefix,
      'tw-fixed tw-overflow-auto tw-inset-0 tw-top-[50px] md:tw-inset-auto md:tw-relative': useTailwindPrefix,
      'md:w-[400px] lg:w-[750px]': hasManyResults && !useTailwindPrefix,
      'md:tw-w-[400px] lg:tw-w-[750px]': hasManyResults && useTailwindPrefix,
   })

   const bodyContainerClassName = classNames({
      'flex md:max-h-[60vh] md:overflow-auto': !useTailwindPrefix,
      'tw-flex md:tw-max-h-[60vh] md:tw-overflow-auto': useTailwindPrefix,
      'flex-wrap': hasManyResults && !useTailwindPrefix,
      'tw-flex-wrap': hasManyResults && useTailwindPrefix,
      'flex-col': !hasManyResults && !useTailwindPrefix,
      'tw-flex-col': !hasManyResults && useTailwindPrefix,
   })

   function onSearchInputChange(e: ChangeEvent<HTMLInputElement>) {
      const text = e.target.value
      let result = []

      if (text !== '') {
         const regex = new RegExp(text, 'i')
         result = hotelList.filter((h) => regex.test(h.name) || regex.test(h.destination.name))
      } else {
         result = hotelList
      }

      setSearchInputValue(text)
      setOptions(getGroupedChains(result))
   }

   function drawIcon() {
      if (version === 'padded') {
         return (
            <div
               className={classNames({
                  'w-4 flex justify-center': !useTailwindPrefix,
                  'tw-w-4 tw-flex tw-justify-center': useTailwindPrefix,
               })}
            >
               {selection ? (
                  selection.destinationType === 'hotel' ? (
                     <BedIcon />
                  ) : (
                     <PinIcon />
                  )
               ) : hasMultiDestination ? (
                  <PinIcon />
               ) : (
                  <BedIcon />
               )}
            </div>
         )
      }
      return (
         <div
            className={classNames({
               'w-4 flex justify-center': !useTailwindPrefix,
               'tw-w-4 tw-flex tw-justify-center': useTailwindPrefix,
            })}
         >
            {selection ? (
               <FontAwesomeIcon icon={selection.destinationType === 'hotel' ? faHotel : faLocationDot} />
            ) : (
               <FontAwesomeIcon icon={hasMultipleDestinations ? faLocationDot : faHotel} />
            )}
         </div>
      )
   }

   return (
      <OverlayTrigger isOpen={isOpen} onToggle={onToggle}>
         <OverlayTrigger.Trigger
            componentTag="div"
            className={classNames({
               'mb-5': myErrors && !useTailwindPrefix,
               'tw-mb-5': myErrors && useTailwindPrefix,
               'md:mb-0': myErrors && !vertical && !useTailwindPrefix,
               'md:tw-mb-0': myErrors && !vertical && useTailwindPrefix,
            })}
         >
            <Field vertical={vertical} {...(myErrors && { hasError: true })}>
               {drawIcon()}
               <div
                  className={classNames({
                     'whitespace-nowrap overflow-hidden text-ellipsis relative': !useTailwindPrefix,
                     'tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-relative': useTailwindPrefix,
                  })}
               >
                  {version === 'padded' && showLabels && !vertical && selection && (
                     <div
                        className={classNames({
                           'hidden absolute md:flex inset-0 text-widget-pill-a11y/75': !useTailwindPrefix,
                           'tw-hidden tw-absolute md:tw-flex tw-inset-0 tw-text-widget-pill-a11y/75': useTailwindPrefix,
                        })}
                     >
                        <div
                           className={classNames({
                              'text-xs truncate': !useTailwindPrefix,
                              'tw-text-xs tw-truncate': useTailwindPrefix,
                           })}
                        >
                           {intl.formatMessage({
                              id: `booker.${selection.destinationType === 'hotel' ? 'hotel' : 'destination'}`,
                           })}
                        </div>
                     </div>
                  )}
                  {drawSelection() || intl.formatMessage({ id: 'booker.hotel' })}
               </div>
            </Field>
            {myErrors && (
               <div
                  className={classNames({
                     'md:mt-2 md:pt-widget-pill-padding-y': version === 'padded' && !useTailwindPrefix,
                     'md:tw-mt-2 md:tw-pt-widget-pill-padding-y': version === 'padded' && useTailwindPrefix,
                     'text-red-400 mt-1 text-sm truncate w-full absolute': !useTailwindPrefix,
                     'tw-text-red-400 tw-mt-1 tw-text-sm tw-truncate tw-w-full tw-absolute': useTailwindPrefix,
                  })}
               >
                  {myErrors?.type === 'required'
                     ? intl.formatMessage({
                          id: `booker.errors.selectHotel${hasMultipleDestinations ? '.destination' : ''}`,
                       })
                     : intl.formatMessage({ id: 'booker.errors.correctFields' })}
               </div>
            )}
         </OverlayTrigger.Trigger>
         <OverlayTrigger.Overlay
            className={classNames({
               'md:rounded-widget-pill-overlays-border-radius': !useTailwindPrefix && !vertical && version === 'padded',
               'md:tw-rounded-widget-pill-overlays-border-radius':
                  useTailwindPrefix && !vertical && version === 'padded',
               'itm-popover-withArrow before:left-5 after:left-5 md:mt-[25px]': !useTailwindPrefix && showArrows,
               'itm-popover-withArrow before:tw-left-5 after:tw-left-5 md:tw-mt-[25px]':
                  useTailwindPrefix && showArrows,
               'after:hidden': !useTailwindPrefix && showArrows && !hasManyResults,
               'after:tw-hidden': useTailwindPrefix && showArrows && !hasManyResults,
               'md:mt-0.5': !useTailwindPrefix && !showArrows,
               'md:tw-mt-0.5': useTailwindPrefix && !showArrows,
               'bg-white md:border border-gray-200 z-10 fixed inset-0 md:shadow-lg md:absolute md:min-w-[280px]':
                  !useTailwindPrefix,
               'tw-bg-white md:tw-border tw-border-gray-200 tw-z-10 tw-fixed tw-inset-0 md:tw-shadow-lg md:tw-absolute md:tw-min-w-[280px]':
                  useTailwindPrefix,
               'md:inset-auto': !vertical && !useTailwindPrefix,
               'md:tw-inset-auto': !vertical && useTailwindPrefix,
               'md:inset-y-auto md:left-auto md:right-0': vertical && !useTailwindPrefix,
               'md:tw-inset-y-auto md:tw-left-auto md:tw-right-0': vertical && useTailwindPrefix,
            })}
         >
            <div
               className={classNames({
                  'md:hidden flex justify-between items-center px-4 border-b border-gray-200 h-[50px]':
                     !useTailwindPrefix,
                  'md:tw-hidden tw-flex tw-justify-between tw-items-center tw-px-4 tw-border-b tw-border-gray-200 tw-h-[50px]':
                     useTailwindPrefix,
               })}
            >
               <div className={classNames({ 'text-3xl': !useTailwindPrefix, 'tw-text-3xl': useTailwindPrefix })}>
                  {intl.formatMessage({ id: 'booker.hotel' })}
               </div>
               <button
                  type="button"
                  onClick={closeSelector}
                  className={classNames({
                     'cursor-pointer text-2xl': !useTailwindPrefix,
                     'tw-cursor-pointer tw-text-2xl': useTailwindPrefix,
                  })}
               >
                  <FontAwesomeIcon icon={faTimes} />
               </button>
            </div>
            <div className={bodyClassName}>
               {hasManyResults && (
                  <div className={classNames({ 'p-4': !useTailwindPrefix, 'tw-p-4': useTailwindPrefix })}>
                     <div
                        className={classNames({
                           'border rounded w-full px-2 flex items-center space-x-2': !useTailwindPrefix,
                           'tw-border tw-rounded tw-w-full tw-px-2 tw-flex tw-items-center tw-space-x-2':
                              useTailwindPrefix,
                           'lg:w-1/2': !useTailwindPrefix && hasManyResults,
                           'lg:tw-w-1/2': useTailwindPrefix && hasManyResults,
                        })}
                     >
                        <FontAwesomeIcon icon={faSearch} />
                        <input
                           id="search"
                           placeholder={intl.formatMessage({ id: 'booker.filter.results' })}
                           className={classNames({
                              'py-2 outline-none w-full': !useTailwindPrefix,
                              'tw-py-2 tw-outline-none tw-w-full': useTailwindPrefix,
                           })}
                           value={searchInputValue}
                           onChange={onSearchInputChange}
                        />
                     </div>
                  </div>
               )}
               <div style={parentStyle}>
                  {drawShadows()}
                  <div className={bodyContainerClassName} onScroll={onScrollHandler} ref={containerRef}>
                     {options.map(renderChainOptions)}
                  </div>
               </div>
            </div>
         </OverlayTrigger.Overlay>
      </OverlayTrigger>
   )
}

export default HotelSelector
